import { SelectOption } from '../Interfaces/PIMs';

const enumToObjects = (
  enumType: any,
  isEnumIdMap?: boolean
): SelectOption[] => {
  if (isEnumIdMap) {
    return Object.keys(enumType)
      .filter((key) => isNaN(Number(key))) // Exclude the numeric keys (for reverse mapping)
      .map((key) => ({
        value: enumType[key as keyof typeof enumType],
        label: key.replace(/([A-Z])/g, ' $1').trim(), // Add spaces before uppercase letters to format the label
      })) as SelectOption[];
  } else {
    return Object.keys(enumType).map((key) => ({
      label: enumType[key]
        .toLowerCase()
        .replace(/(?:^|\s)\w/g, function (match: string) {
          return match.toUpperCase();
        }),
      value: enumType[key],
    })) as SelectOption[];
  }
};

export default enumToObjects;
